module.exports = {
  // 头部
  nav: {
    title01: '首页',
    title02: "关于博商",
    title03: "教学中心",
    title04: "课程服务",
    title05: "实战导师",
    title06: "企业学员",
    title07: "加入博商",
    title8: "品牌简介",
    title9: "使命与愿景",
    title10: "创始人介绍",
    title11: "发展历程",
    title12: "业务架构",
    title13: "社会责任",
    title14: "社会责任",
    title15: "所获荣誉",
    title16: "博商动态",
    title17: "博商动态",
    title18: "新闻动态",
    title19: "行业报告",
    title20: "博商出版",
    title21: "课程资讯",
    title22: "产品亮点",
    title23: "课程一览表",
    title24: "个人学习系统班",
    title25: "团队共学研习社",
    title26: "陪跑系列",
    title27: "领跑系列",
    title28: "线上系列",
    title29: "课程口碑",
    title30: "师资实力",
    title31: "师资口碑",
    title32: "师资介绍",
    title33: "博商师资导师",
    title34: "学员概述",
    title35: "优秀校友",
    title36: "优秀校友",
    title37: "上市学员企业",
    title38: "资源平台",
    title39: "合作优势",
    title40: "渠道合作",
    title41: "师资合作",
    title42: "课程资讯",
    title43: "",
    title44: "",
    title45: "",
    title46: "",
    title47: "",
    title48: "",
    title49: "",
    title50: "",
    titleAi:'AI产品'
  },
  // 底部
  footer: {
    one02: '博商管理科学研究院公众号',
    one03: '下载博商APP',
    one04: '下载博商小麦APP',
    one05: '粤ICP备12055513号',
    one07: '版权所有： 公司：深圳市博商管理科学研究院股份有限公司',
    one08: '关注我们',
    one9: '网站导航',
    one10: '首页',
    one11: '关于博商',
    one12: '课程服务',
    one13: '加入博商',
    one14: '渠道合作',
    one15: '师资合作',
  },

  // 面包屑
  breadcrumb:{
    breadText1:"首页",  // breadcrumb.breadText1
    breadText2:"关于博商",
    breadText3:"博商动态",
    breadText4:"新闻动态",
    breadText5:"行业报告",
    breadText6:"博商出版",
    breadText7:"实战导师",
    breadText8:"师资介绍",
    breadText9:"博商实战导师",
    breadText10:"企业学员",
    breadText11:"优秀校友",
    breadText12:"社会责任",
    breadText13:"课程服务",
    breadText14:"个人学习系统班",
    breadText15:"课程资讯",
    breadText16:"",
    breadText17:"",
    breadText18:"",
    breadText19:"",
  },

  // 公用
  homeCommon: {
    showMore: "查看更多",
  },
  // 首页
  homeVideo: {
    homeTitle1: "博商管理科学研究院<span>「专注企业管理培训长达{years}年的教育机构 」</span>",
    homeText1: "经过{years}年稳健快速发展，博商品牌版图持续扩张。在国内，博商以珠三角地区作为战略枢纽，构建覆盖北京、上 海、广州等全国12个重点城市的分教中心网络。博商于 2023年正式开展全球拓展步伐，现已在东京、新加坡、 吉隆坡、雅加达、胡志明市设立分教中心。博商员工正齐心协力为全球企业家及商界精英提供高效优质的 教学服务与学习体验。",
    homeText1_1: "2024年起，博商深度布局AI+企业管理教育。如今，博商AI正在引领企业管理迈入智能时代。依托30万+真实企业案例沉淀，结合行业一线实战经验，打造更懂中小企业的智能化管理解决方案。每一课配套实战方案，内容即学即用、结果可见可落地，全面帮助企业管理省心、省力、提效。",
    homeVideoLeft1: "<span class='homeNum'>1个</span><span>OMO学习平台</span>",
    homeVideoLeft2: "<span class='homeNum'>17个</span><span>城市教学中心</span>",
    homeVideoLeft3: "<span class='homeNum'>{years}年</span><span>陪伴实战落地</span>",
  },
  // 首页
  homeTeacher: {
    homeTitle2: "<span>师资阵容</span>",
    homeText2: "博商所有导师均来自国内知名企业或咨询机构，在专业领域平均有15年以上的实战经验和学术研究经验，人均授课辅导超过50家企业，拥有十分硬核的实战落地经验。迄今为止，博商已打造100位+商业类头部名师IP，已赋能30w+企业家实现增长,总粉丝数超2亿，成为同行业佼佼者。",
    homeTeacherContent1: "100位⁺实战商业导师",
    homeTeacherContent2: "15年⁺企业训战经验",
    homeTeacherContent3: "1500⁺企业实战案例",
  },
  // 首页
  homeCourse: {
    homeTitle3: "<span>实战课程</span>",
    homeText3: "针对当今企业所面临的管理难题，以及新一代企业家的学习需求，博商创新实践 OMO(线上线下融合)教学模式，充分融合20年企业管理教育经验，为企业家定制出四大经营管理实践体系课程，涵盖个人学习系统班、团队共学研习社、陪跑系列及领跑系列。",
  },
  // 首页
  home: {
    text1: "个人学习系统班",
    text2: "团队共学研习社",
    text3: "陪跑系列",
    text4: "领跑系列",
    text5: "线上学习",
    text6: "企业学员",
    text7: " 迄今为止，博商拥有超30万的企业家校友，学员企业覆盖200+细分行业领域，包括但不限于IT互联网、跨境电商、新能源、预制菜、环保、家居、家电、烘焙、自媒体、酒店、母婴、玩具、旅行、金融、教育、房地产、工业设计、建筑、交通运输、日化、生物、医疗、生活服务…….",
    text8: "200⁺ 行业领域覆盖",
    text9: "30万⁺ 企业及企业家",
    text10: "30⁺ 学员企业成功上市",
    text11: "合作优势",
    text12: "博商用{years}年的时间搭建平台、布局资源，持续创新培育模式，打造了一条契合中小民营企业发展需求的完整服务链。作为国内资深的民营商学院，博商已于2021年、2022年连续两年入选中国最佳企业家教育机构排行榜TOP5。",
    text13: "渠道合作",
    text14: "目前已经公开招募合作渠道30余家，分布在全国各大一线城市，负责赋能渠道，持续探索合作增长点，不断实现渠道增量。",
    text15: "师资合作",
    text16: "博商在行业内率先探索短视频获客模式，打造线上流量导师，实现业绩逆势增长70%，迄今为止，博商已打造100多位商业类头部名师IP，已赋能30w+企业家实现增长,总粉丝数超2亿。",
  },

  // 关于博商
  about: {
    prizesDec1: "2021年度影响力企业管理教育品牌",
    prizesDec2: "企业评级AAA级信用企业",
    prizesDec3: "年度行业领创奖",
    prizesDec4: "民营企业联合研究中心",
    prizesDec5: "2020年度行业标杆教育集团",
    prizesDec6: "2020年度影响力民企商学院",
    prizesDec7: "2021中国最佳企业家教育机构排行榜第4名",
    prizesDec8: "2022中国最佳企业家教育机构排行榜第3名",
    prizesDec9: "阳光同行奖",
    prizesDec10: "第三届引擎奖·年度新锐大奖",
    prizesDec11: "2025年度 企业家教育领军品牌",
    prizesDec12: "2025福布斯 中国商业知识影响力系列评选 — 行业影响力机构",
    aboutText1: "品牌简介",
    aboutText2: "更贴近民企的实战管理研究院",
    aboutText3: "深圳市博商管理科学研究院股份有限公司（简称：博商），始创于2006年，以“民企成长加速器”为定位，秉承“研究民企、服务民企、传播民企”的办学理念，为中国民营企业家提供管理培训、咨询辅导和资源互通等企业全生命周期服务。",
    aboutText4: "博商创新实践OMO（线上线下相结合）教学模式，为企业家定制出四大经营管理实践课程——个人学习系统班、团队共学研习社、陪跑系列、领跑系列，并开放线上学习平台——博商小麦，全面、精准助力企业家学员快速成长。",
    aboutText5: "经过{years}年稳健快速发展，博商品牌版图持续扩张。在国内，博商以珠三角地区作为战略枢纽，构建覆盖北京、上 海、广州等全国12个重点城市的分教中心网络。博商于 2023年正式开展全球拓展步伐，现已在东京、新加坡、 吉隆坡、雅加达、胡志明市设立分教中心。博商员工正齐心协力为全球企业家及商界精英提供高效优质的 教学服务与学习体验。          <div style=' margin-top:10px'>未来，博商将持续壮大队伍，深入更多地区和城市，为更多民企赋能。</div> ",
    aboutText6: "使命与愿景",
    aboutText7: "博商院训",
    aboutText8: "博学笃志 商道弘毅",
    aboutText9: "博商致力于培养新一代热爱学习，拥有超越赚取利润的追求，并坚持通过商业正道获得成功的企业家。",
    aboutText10: "使命",
    aboutText11: "推动知识实践应用，创造世界美好",
    aboutText12: "愿景",
    aboutText13: "以专业和科技成为企业首选的成长伙伴，让客户因结果而托付，让员工因成就而发光",
    aboutText14: "价值观",
    aboutText15: "成就客户 诚信进取<br> 开放创新 专业协作",
    aboutText16: "创始人介绍",
    aboutText17: "曾任伟",
    aboutText18: "博商管理科学研究院联合创始人、院长",
    aboutText19: "新加坡沙滩博商董事长",
    aboutText20: "香港理工大学管理学博士",
    aboutText21: '知名企业教练与实战专家，提出知名的"博三角”概念',
    aboutText22: "20年致力于成长型企业系统管理解决方案的研究实践",
    aboutText23: "辅导安奈儿、奥拓、海洋王等多家企业实现规模性增长",
    aboutText24: '曾院长擅长商业模式创新设计,长期致力于企业成长性研究、组织运营力打造、团队执行力建设，并提出了知名的企业成长型模型一一 <span class="rightRed">“博三角”</span> 的概念。<span class="rightRed">“博三角”</span class=>揭示了企业稳健成长必须具备的三个条件:清晰的战略目标、高效的组织运营力和总裁影响力。战略是公司的方向，为运营提供指南，为资源整合提供依据;组织运营力是企业发展最关键、最难的因素，决定企业的效率;总裁是企业的掌舵人，其影响力会给企业文化打上深深的烙印。<span class="rightRed">“博三角”</span>现已成为推动民营企业成长发展的利器。',
    aboutText25: "刘炳成",
    aboutText26: "博商管理科学研究院联合创始人、院长",
    aboutText27: "清华大学深圳研究生院博商民企联合研究中心领导力专家",
    aboutText28: "原南京陆军学校优秀军事教官",
    aboutText29: "“突破性领导力”开发人",
    aboutText30: '刘院长早年从军，入解放军南京陆军学校深造，因成绩优异被留校任教，从事军事组织指挥的教育训练和研究工作。期间因成绩突出，曾多次被南京陆军学校授予优秀军事教官荣誉称号。<br>刘院长擅长激烈竞争领域组织领导力的教育培训。和平年代商场如战场，民企身在商战第一线亟待提升系统专业的组织管理能力。为此，刘院长用其擅长的军事教练技术为民企培训赋能，和博商人一起陪伴民企领导，用 <span class="rightRed">“百战归来再读书”</span>的学习方式，有效提升其系统管理能力，长期以来在助力民企持续健康发展上取得卓越成效。',
    aboutText31: "发展历程",
    aboutText32: '2020-至今 <span class="rightRed">（开拓）</span>',
    aboutText33: "从线下教学转为OMO模式",
    aboutText34: '2015-2019年<span class="rightRed">（独立） </span>',
    aboutText35: "博商独立自主发展",
    aboutText36: '2006-2014年 <span class="rightRed">（增长）</span>',
    aboutText37: "隶属于清华大学深圳研究生院",
    aboutText38: "业务架构",
    aboutText39: "社会责任",
    aboutText40: "企业是社会的器官，其生存必须依赖社会为其提供的一切。博商管理在助力中国民企经济发展的过程中，主动承担并积极履行着相应的社会责任。2015年7月20日，博商管理成立了“博商公益基金会”，以“博爱、聚善、风险、服务”为理念，为博商同学和热心公益的人士提供了一个公共平台，让成员个体以组织的形式，集合更多更大的力量开展社会公益服务活动，传递正能量，促进社会和谐。",
    aboutText41: "所获荣誉",
    aboutText42: "博商动态",
    aboutText43: "新闻动态",
    aboutText44: "行业报告",
    aboutText45: "博商出版",
    aboutText46: "项目情况",
    aboutText47: "课程资讯",
  },

  // 教学中心
  teaching: {
    teachListCompany1: "深圳总部",
    teachListAddress1: "地址: 深圳市南山区前海信利康大厦16F/17F/21F/25F/33F",
    teachListCompany2: "北京分院",
    teachListAddress2: "地址: 北京市朝阳区香宾路66号保利广场东座二层",
    teachListCompany3: "上海分院",
    teachListAddress3: "地址: 上海市青浦区高光路169弄虹桥时代广场2幢2号楼5层",
    teachListCompany4: "广州分院",
    teachListAddress4: "地址: 广东省广州市海珠区琶洲街道铭丰广场A栋2810单元",
    teachListCompany5: "佛山分院",
    teachListAddress5: "地址: 佛山市南海区桂澜北路26号招商置地中心3座11楼",
    teachListCompany6: "东莞分院",
    teachListAddress6: "地址: 东莞市松山湖园区科技二路5号中国电子南方软件园A座1006室",
    teachListCompany7: "杭州分院",
    teachListAddress7: "地址: 杭州市滨江区聚业路1号兴耀科创城·杭州双碳技术产业园C幢5楼",
    teachListCompany8: "苏州分院",
    teachListAddress8: "地址: 苏州高新区狮山路22号人才广场403/1001/1007/1008室",
    teachListCompany9: "重庆分院",
    teachListAddress9: "地址: 重庆市南岸区南滨路22号长江国际写字楼25楼",
    teachListCompany10: "成都分院",
    teachListAddress10: "地址: 成都市成华区成华发展大厦18楼",
    teachListCompany11: "长沙分院",
    teachListAddress11: "地址: 长沙市芙蓉区万家丽中路一段176号旺德府国际大厦13楼",
    teachListCompany12: "武汉分院",
    teachListAddress12: "地址: 湖北省武汉市徐东大街89号金禾中心2801-02",
    teachListCompany13: "新加坡分院",
    teachListAddress13: "地址：163 Kallang Way , #07-13 , Singapore (349256)",
    teachListCompany14: "吉隆坡分院",
    teachListAddress14: "地址：Level 27, 1 Powerhouse, No. 1, Persiaran Bandar Utama,Bandar Utama, 47800 Petaling Jaya, Selangor Malaysia",
    teachListCompany15: "雅加达分院",
    teachListAddress15: "地址：Landmark Pluit Gedung B9 / Lantai 12 (Jl. Pluit Selatan Raya RT.6/RW/10, Pluit Penjaringan, Jakarta Utara)",
    teachListCompany16: "胡志明市分院",
    teachListAddress16: "地址：Tầng 11, Khu cao ốc văn phòng - thương mại - dịch vụ tại lô 5.5, số 8-10 đường Mai Chí Thọ, Phường Thủ Thiêm, Thành phố Thủ Đức, Thành phố Hồ Chí Minh, Việt Nam",
    teachText1: "博商区域版图",
    teachText2: "经过{years}年稳健快速的发展，博商品牌版图持续扩张。目前，博商以珠三角为战略枢纽，已拓展至全国12个重点城市及海外多个地区，服务10万+企业家学员。1800+员工，齐心协力为博商学员提供高效优质的教学服务和学习体验。",
    teachText3: "未来，博商将持续壮大队伍，深入更多地区和城市，为更多民企赋能。",
  },

  // 课程服务
  course: {
    courseText1: "产品亮点",
    courseText2: " 针对当今企业所面临的运营管理难题，以及新一代企业家的学习习惯和需求，博商创新实践OMO教学模式，充分融合17年线下优势及多年线上管理培训课程经验,为企业家定制出四大经营管理实践体系课程,涵盖个人学习系统班、团队共学研习社、陪跑系列及领跑系列，以及一个线上学习平台——博商小麦。",
    courseText3: "通过“有模型、有流程、有工具、有案例、有练习”的“五有课程”和“预学习用链”的教学方法，打磨出了实战落地的核心优势。",
    courseText4: "四大体系·九大领域",
    courseText5: "五有课程",
    courseText6: "教学特色",
    courseText7: "线上线下",
    courseText8: "课程一览表",
    courseText9: "课程口碑",
    courseText10: "潘宣成学员",
    courseText11: "<text class='classSty'>学习课程：</text>财务致胜特训营",
    courseText12: "课程中穿插了许多老师的实战经历，由浅入深，让原本晦涩难懂的财务内容增加了几分真实和趣味。让我明白，财务并非只是文职统计工作，而是与实际业务密切相关的，运用得当，就能为企业实现真正的开源节流、降本增效。",
    courseText13: "王顿学员",
    courseText14: "<text class='classSty'>学习课程：</text>卓越组织进化系统",
    courseText15: "参加课程后，学到了：1.绩效要切实遵循smart原则，落实到每一条；2.绩效面谈要讲究方式方法，不能所有人一个模式；3.绩效面谈前要充分考虑清楚对象的现实需求；4.公司战略目标要拆分到部门业绩，而且要可量化；5.在绩效考评上，要逻辑清晰、逐步递增。",
    courseText16: "俞卫华学员",
    courseText17: "<text class='classSty'>学习课程：</text>新商业驱动增长",
    courseText18: "老师的课绘声绘色，让人记忆犹新。比如，用全局眼光去看待行业及企业所在的位置，在行业有了头部的情况下分析挖掘行业细分领域的市场前景，以此为抓手，完善自己熟悉的行业、熟悉的事物；同时，在危机还没到来之前，如何提早觉察并布局行业。",
    courseText19: "郑成林学员",
    courseText20: "<text class='classSty'>学习课程：</text>F8营销系统",
    courseText21: "销售只是营销最初始的一个内容，而营销却是一套整体的系统，从市场调研、战略规划、品牌策划，到产品策划以及渠道建设、销售推广等，缺一不可。因此,要想做成一个好的品牌，需要先找到一个好的品类，而品类细分才能更聚焦，这些认知对我来说，可谓受益匪浅。",
    courseText22: "个人学习系统班",
    courseText23: "团队共学研习社",
    courseText24: "陪跑系列",
    courseText25: "领跑系列",
    courseText26: "线上系列",
    // tableDataLabel表头
    tableDataLabel1: "课程系列",
    tableDataLabel2: "个人学习系统班",
    tableDataLabel3: "团队共学研习社",
    tableDataLabel4: "陪跑系列",
    tableDataLabel5: "领跑系列",
    tableDataLabel6: "线上系列",

    // tableDataList表格内容
    tableDataListDate1: '适用人群',
    tableDataListName1: '创始人、高管',
    tableDataListAddress1: '创始人、中高管/业务线负责人',
    tableDataListTogether1: '创始人、创始人、核心高管',
    tableDataListLead1: '企业、团队',
    tableDataListOnline1: '创业者、职场精英',

    tableDataListDate2: '授课时间',
    tableDataListName2: '1年',
    tableDataListAddress2: '2-3天',
    tableDataListTogether2: '3-12个月',
    tableDataListLead2: '3-12个月',
    tableDataListOnline2: '按课程实际时间、无限回放',

    tableDataListDate3: '上课地点',
    tableDataListName3: '全国',
    tableDataListAddress3: '全国',
    tableDataListTogether3: '全国',
    tableDataListLead3: '入企+线上',
    tableDataListOnline3: '线上',

    tableDataListDate4: '亮点项目/课程',
    tableDataListName4: '《总裁项目》 <br> 《英才项目》<br> 《资本项目》',
    tableDataListAddress4: '《赢在短视频》<br>《赢在直播》<br>《赢在股权》<br>《赢在财税》<br>《赢在销售》<br>《引爆组织能力》',
    tableDataListTogether4: '《战略教练陪跑项目》 <br>《引爆组织90天〉',
    tableDataListLead4: '企业深度管理咨询 <br>企业短视频深度咨询',
    tableDataListOnline4: '《曾任伟：商业模式落地特训营》<br>《张琦：引爆流量全渠道增长》',

    tableDataListDate5: '',
    tableDataListName5: 'https://www.baidu.com/',
    tableDataListAddress5: 'https://www.baidu.com/',
    tableDataListTogether5: 'https://www.baidu.com/',
    tableDataListLead5: 'https://www.baidu.com/',
    tableDataListOnline5: 'https://www.baidu.com/',
  },

  // 实战导师
  combat: {
    combatText1: "师资实力",
    combatText2: "博商所有导师均来自国内知名专家或咨询师，在专业领域拥有15年以上的实战经验和学术研究，人均授课辅导超过50家企业，拥有十分硬核的实战落地经验。迄今为止，博商已打造100位+商业类头部名师IP，已赋能30w+企业家实现增长，总粉丝数超2亿，并实现巨量导流变现转化，成为同行业佼佼者。",
    combatText3: "100位⁺",
    combatText4: "实战导师",
    combatText5: "15位⁺",
    combatText6: "训战经验",
    combatText7: "1500位⁺",
    combatText8: "实战案例",
    combatText9: "师资口碑",
    combatText10: "学员评价 <span>部分</span>",
    combatText11: "实战指导：股权设计方向",
    combatText12: "学习收获：",
    combatText13: "老师的入企咨询辅导，让我当下回想起来还很兴奋，忍不住和管理层们分享讨论，一个下午的时间，老师对我们提出的股权设计问题层层剖析、见招拆招，相当有料，且非常接地气。不愧是来自500强企业的实战导师，入企的指导让我这5年的学习融会贯通，知识点在实践中得以升华，真心感谢～",
    combatText14: "——大任空调 曹任",
    combatText15: "实战指导：业务增长方向",
    combatText16: "学习收获：",
    combatText17: "邀请老师到企业里做了诊断指导，在场的每位同事都感触颇深，给了我们很多新的思路。接手公司后，我总想打破固有的模式，创造新的增长点，或开辟新的业务板块，可是老师点醒了我，得先做重要而紧急的事，让局中人的我醍醐灌顶。",
    combatText18: "——成都德昆集团 王总",
    combatText19: "师资标准",
    combatText20: "二十年磨一剑，博商磨出了“有实战经验、懂中小民企、授课演绎好、有爱心”的“四有师资”标准，并结合“有模型、有流程、有工具、有案例、有练习”的“五有课程”，为企业提供问题的学习解决方案。",
    combatText21: "师资介绍",
    combatText22: "博商名师大讲堂",
    combatText23: "博商实战导师",
    combatText24: "博商定期邀请国际领袖人物、知名企业家、商业知识大咖等，为学员带来最前沿的政策和知识，不断开拓学员视野。",
    combatText25: "博商与各专业领域实战导师开展深度合作，从始至终陪伴学员，让学员获得有效的实战经验，实现质的飞跃。",
    combatText26: "",
    combatText27: "",
    combatText28: "",
    combatText29: "",
    combatText30: "",
    combatText31: "",
    combatText32: "",
    combatText33: "",
  },

  // 企业学员
  student: {
    studentText1: "学员概述",
    studentText2: "迄今为止，博商拥有超30W的企业家校友，学员企业覆盖200+细分行业领域，包括但不限于IT互联网、安防、宠物、电商、电子、房地产、工业设计、化工行业、新能源、环保、加工业、家居、家用电器、建筑、交通运输、教育、金融、农林牧副渔、批发和零售、汽车、轻工业、日化、奢侈品、生活服务、生物、文体、文娱、医疗……",
    studentText3: "200⁺",
    studentText4: "行业领域覆盖",
    studentText5: "30万⁺",
    studentText6: "企业及企业家",
    studentText7: "30⁺",
    studentText8: "家企业成功上市",
    studentText9: "优秀校友",
    studentText10: "上市学员企业",
    studentText11: "资源平台",
    studentText12: "佳士科技",
    studentText13: "股票代码-300193",
    studentText14: "昌红科技",
    studentText15: "股票代码-300151",
    studentText16: "捷顺科技",
    studentText17: "股票代码-002609",
    studentText18: "星源材质",
    studentText19: "股票代码-300568",
    studentText20: "长园集团",
    studentText21: "股票代码-600525",
    studentText22: "科陆电子",
    studentText23: "股票代码-002121",
    studentText24: "名雕装饰",
    studentText25: "股票代码-002830",
    studentText26: "新纶新材",
    studentText27: "股票代码-002341",
    studentText28: "新宏泽",
    studentText29: "股票代码-002836",
    studentText30: "拓斯达",
    studentText31: "股票代码-300607",
    studentText32: "胜蓝股份",
    studentText33: "股票代码-300843",
    studentText34: "衍生集团",
    studentText35: "股票代码-06893",
    studentText36: "三峡水利",
    studentText37: "股票代码-600116",
    studentText38: "意华股份",
    studentText39: "股票代码-002897",
    studentText40: "崧盛股份",
    studentText41: "股票代码-301002",
    studentText42: "奥海科技",
    studentText43: "股票代码-002993",
    studentText44: "英威腾",
    studentText45: "股票代码-002334",
    studentText46: "证通电子",
    studentText47: "股票代-002197",
    studentText48: "快意电梯",
    studentText49: "股票代码-002774",
    studentText50: "雪天盐业",
    studentText51: "股票代码-600929",
    studentText52: "达瑞电子",
    studentText53: "股票代码-300976",
    studentText54: "超频三",
    studentText55: "股票代码-300647",
    studentText56: "齐心集团",
    studentText57: "股票代码-002301",
    studentText58: "金博股份",
    studentText59: "股票代码-688598",
    studentText60: "德生科技",
    studentText61: "股票代码-002908",
    studentText62: "普邦股份",
    studentText63: "股票代码-002663",
    studentText64: "汇创达",
    studentText65: "股票代码-300909",
    studentText66: "华宝新能",
    studentText67: "股票代码-301327",
    studentText68: "捷邦科技",
    studentText69: "股票代码-301326",
    studentText70: "唯特偶",
    studentText71: "股票代码-301319",
    studentText72: "佳裕达",
    studentText73: "NASDAQ: JYD",
    studentText74: "博商汇",
    studentText75: "采用独特的互联网蜂巢模式，以创新为驱动，联合各大行业协会、主流媒体、民营企业研究机构以及当代商业思想家、行业专家、企业领袖，为学员搭建终身学习平台。",
    studentText76: "博商资源汇",
    studentText77: "打造博商同学自己的资源整合平台，定期开展活动，让资源高效对接、精准匹配，帮助企业快速开拓市场，持续创新赋能，现有大湾区总汇、博明分汇、博龙分汇。",
    studentText78: "博商百人汇",
    studentText79: "致力于培养百位未来行业领军企业家，通过引进知名学者、企业家作为导师顾问，以主题学习、标杆企业参访、院长私董会、资源整合等形式，持续提升学员企业的市场竞争力和行业影响力。",
    studentText80: "优秀学员",
    studentText81: "学员案例",

  },

  // 加入博商
  join: {
    joinText1: "合作优势",
    joinText2: "行业前景",
    joinText3: '据共研产业研究院数据，2026年中国企业培训市场整体规模预计达到4069.5亿元，同比增长9.8%。行业格局仍呈高度分散的"水滴型"发展趋势，头部机构营收占整体市场规模不足0.1%，这意味着中国企业在经营管理上有极大的提升空间，属于蓝海行业，更早开拓布局的企业将获得更大的发展优势。',
    joinText4: "市场监管总局数据显示，截至2026年4月底，全国登记在册民营企业达6102.2万户，同比增长5.6%，占企业总量的92%以上。平均每天新设约2.3万家，经营主体发展稳中向好。构成了中国经济最活跃的微观基础。",
    joinText5: "民营企业突破6100万户",
    joinText6: "中国中小企业协会数据显示，国内新注册企业1年内存活率约60%，3年内存活率不足20%，5年内存活率仅7%-8%。约70%的创业失败源于资金链断裂，而根源往往是缺乏系统化的经营管理体系，学习专业化经营管理已成为企业长青的基础和刚需。",
    joinText7: "专业化管理成为企业刚需",
    joinText8: '世界银行对中国2189家企业的调查结果显示，在59项营商环境测评点中，中国有12项达到全球最优水平，6个评估领域数据全部优于中位数。2025年5月20日《民营经济促进法》正式施行，系统回应了民营企业长期面临的核心问题，被定位为护航民营经济的"里程碑事件"。',
    joinText9: "营商环境持续优化",
    joinText57: '89%的企业已将"培训ROI可量化"列为核心评估标准，82%的企业首选实战化课程，中小企业在线培训需求增速达72%，远超大型企业的45%。AIGC课程学习时长同比增长54倍，企业培训正从"可选支出"升级为"刚性投入"。',
    joinText58: "AI重塑培训价值",
    joinText10: "博商实力",
    joinText11: "17",
    joinText12: "个",
    joinText13: "城市教学中心",
    joinText14: "100",
    joinText15: "位",
    joinText16: "实战导师",
    joinText17: "200",
    joinText18: "个",
    joinText19: "行业覆盖",
    joinText20: "30",
    joinText21: "万",
    joinText22: "学员认证",
    joinText23: "20",
    joinText24: "年",
    joinText25: "陪伴落地",
    joinText26: "200",
    joinText27: "个",
    joinText28: "实力产品",
    joinText29: "合作布局",
    joinText30: "博商深度洞察民营经济发展趋势，用17年的时间搭建平台、布局资源，将更具开放共赢的商业格局和转化价值。博商已面向全国开放渠道招生、师资合作招募，实现全力聚合资源，赋能品牌运营全方位创新。",
    joinText31: "渠道合作",
    joinText32: "博商全国渠道合作部，于2023年3月正式成立，旨在招募全行业渠道代理商，与博商共创最优合作模式，共享平台资源，实现渠道增量。现已面向全国开放渠道代理，欢迎各行业渠道代理商前来合作，一起助力中国中小民企的发展。",
    joinText33: "合作方式",
    joinText34: "专业团队支持、市场推广指导、信息系统支持、赛事活动支持、定期人员培训",
    joinText35: "合作价值",
    joinText36: "共享平台资源：",
    joinText37: "博商作为一家20年的资深企培公司，服务超过30W+企业及企业家 学员，覆盖200+行业资源。",
    joinText38: "管理能力赋能：",
    joinText39: "博商作为行业内TOP3的企培公司，深度洞察前沿科技与行业发展的 关系，提供最新政策宣导、体系系统操作、品牌师资赋能、实战产品赋能等科学管理方法",
    joinText40: "销售转化分红：",
    joinText41: "不断探索合作增长点，实现渠道利润增长，获得行业内可观的销售转化分红",
    joinText42: "师资合作",
    joinText43: "博商师资事业部，专注于打造符合中国中小民企实战派企业管理导师，从导师个人IP品牌打造、线上课程合作、总裁班长期项目等方面，全力助力民企经济发展。迄今为止，博商已打造30多位商业类头部名师IP，总粉丝数超2亿，成为同行业佼佼者。",
    joinText44: "合作方式",
    joinText45: "个人IP品牌打造、线上课程合作、总裁班长期项目",
    joinText46: "选拔流程",
    joinText47: "①评估：师德风评和课程效果、是否适合中小企业落地",
    joinText48: "②磨课：使课程符合博商学员实际情况",
    joinText49: "③试讲：专业师资和学员课后反馈",
    joinText50: "④正式合作",
    joinText51: "联系方式",
    joinText52: "如需进一步了解合作，请扫二维码联系我们",
    joinText53: "右侧扫码添加老师联系方式→",
    joinText54: "联系方式",
    joinText55: "如需进一步了解合作，请扫二维码联系我们",
    joinText56: "右侧扫码添加老师联系方式→",

  },

  // 社会责任
  responsibility: {
    resText1: "社会责任",
    resText2: "基金会简介",
    resText3: "深圳市博商公益基金会是由深圳市博商管理科学研究院股份有限公司发起，经深圳民政局审核批准，于2015年成立的非公募基金会。2021年被认定为慈善组织；2022年博商公益基金会义工队正式成立，党支部成立；2023年11月被评为3A级社会组织。",
    resText4: '基金会以"分享爱，传递爱，让博爱温暖世界"为愿景，以"博施公益种子，弘扬慈善精神"为使命，聚焦"儿童关怀与教育发展"、"美丽城市与乡村振兴"、"自然灾害与应急救护"、"敬老安老与助孤帮残"四大板块，通过开展各类公益活动项目，号召社会各界爱心人士共同助力慈善事业，激发更多人的慈善热情，积极参与慈善公益，将爱心和关怀传递到世界每一个角落，为社会的进步与发展贡献力量。',
    resText6: "基金会简介",
    resText7: "儿童关怀与教育发展",
    resText8: '基金会秉持办会理念，搭建公益助学平台，改善贫困儿童、流动儿童、留守儿童困境，提供青少年儿童健康成长服务，帮助学校改善教学设施，资助家庭困难的学子成才圆梦。自2010年来，基金会捐建"爱心图书馆"20余所、爱心小学3所；孔子雕像10余座；举办关爱留守儿童候鸟计划共7季，惠及700+留守儿童；2024年创新心目"博爱班"，助力优困学子圆梦；更在四川、贵州、云南、福建、广西、湖北等多个地区深入开展定向助学项目……博商人有爱，更以实际行动关怀儿童，支援儿童教育发展，为孩子们送去社会的温暖。',
    resText9: "",
    resText10: "自然灾害与应急救护",
    resText11: "在灾难面前，我们不仅是救援者，更是希望的传递者。基金会每一次及时的救援、每一次有效的救助，都可能成为受灾群众生命安全的保障，为他们带去多一份希望。",
    resText12: "美丽城市与乡村振兴",
    resText13: "城市与乡村，如同并蒂之花，共同绽放了人类文明的绚丽画卷。作为公益事业的推动者，基金会致力于以公益活动为纽带，助力城市绿色、可持续发展，同时积极投身于乡村振兴的伟大事业中，让乡村重焕生机。",
    resText14: "敬老安老与助孤帮残",
    resText15: "在社会的大家庭中，老年人和孤儿、残障人士都是需要特殊关爱的群体。基金会基金开展敬老帮扶侧弯儿童、先心病患者、关爱贫困老人家庭等项目，将敬老安老与助孤帮残两大公益项目紧密结合，为这些弱势群体提供帮助和支持，让每一个生命都能得到尊重和关爱。",
    resText16: "",
    resText17: '2021–2024年 开展7期应急救护员培训',
    resText18: '2021年 "豫"我同心河南水灾救援',
    resText19: '2024年 "梅州平远洪情" 救助',
    resText20: '2020年 "同心行动" 新冠疫情捐赠',
    resText21: '开展6届 "博商林" 公益植树活动',
    resText22: '组织3届 "生命之光" 千人献血活动',

  },

  // 新闻动态 {{ $t('boSumDynamic.dynamicText1') }}
  boSumDynamic: {
    dynamicText1: "新闻动态",
    dynamicText2: "行业报告",
    dynamicText3: "博商出版",
    dynamicText4: "媒体联系",
    dynamicText5: "邮箱",
    dynamicText6: "地址：深圳市前海深港合作区妈湾十九单元03街坊信利康大厦17F",
    dynamicText7: "新闻动态",
    dynamicText8: "行业报告",
    dynamicText9: "如需进一步了解合作，请扫二维码联系我们",
    dynamicText10: "右侧扫码添加老师联系方式→",
    dynamicText11: "如需下载完整报告，请联系博商行研中心-周老师",
    dynamicText12: "右侧扫码添加老师联系方式→",
    dynamicText13: "博商管理所有导师均为国内外知名专家或咨询师，在专业领域平均有15年以上的实战经验和学术研究，人均授课辅导超过50家企业，拥有十分硬核的实战落地经验。迄今为止，博商已打造100多位商业类头部名师IP，已赋能30w+企业家实现增长，总粉丝数超2亿，成为同行业佼佼者。",
    dynamicText14: "请选择",
    dynamicText1401: "请输入",
    dynamicText15: "搜索",
    dynamicText16: "迄今为止，博商拥有超10W的企业家校友，学员企业覆盖200+细分行业领域，包括但不限于IT互联网、跨境电商、新能源、预制菜、环保、家居、家电、烘焙、自媒体、酒店、母婴、玩具、旅行、金融、教育、房地产、工业设计、建筑、交通运输、日化、生物、医疗、生活服务…",
    dynamicText17: "课程资讯",
    dynamicText18: "",
    dynamicText19: "",
    dynamicText20: "",
  },

  // 课程资讯  {{ $t('consult.consultText1') }}
  consult:{
    consultText1:"我要咨询",
    consultText2:"姓名",
    consultText3:"请输入您的姓名",
    consultText4:"联系电话",
    consultText5:"请输入您的联系电话",
    consultText6:"公司名称",
    consultText7:"请输入您的公司名称",
    consultText8:"职位",
    consultText9:"请输入您的职位",
    consultText10:"温馨提示",
    consultText11:'1.欢迎您咨询博商的课程，请认真填写带<i style="color: red;"> *</i>的必填栏目。',
    consultText12:"2.为方便与您联系，请留下真实信息，请放心，这些个人信息我们不会对外公开。谢谢支持！",
    consultText13:"提交",
    consultText14:"招生热线： 18927497646",
    consultText15:"招生邮箱： yangqing@bosum.com",
    consultText16:"",
  },

  // 后面修改的课程 {{ $t("courseC.courseCText1") }}
  courseC:{
    courseCText1:"课程价值",
    courseCText2:"  基于20年企业管理实战教育经验，博商致力于为中小企业及企业家个人，提供科学前沿的管理知识，让做生意有方法可循。100+位实战经验丰富的专业导师，将为企业家提供真实有效的落地课程及指导，陪伴学员解决企业管理经营中遇到的实际问题。",
    courseCText3:"全面提升管理认知",
    courseCText4:"打造企业竞争优势",
    courseCText5:"顶尖高手实战指导",
    courseCText6:"线上线下无缝融合",
    courseCText7:"",
    courseCText8:"",
    courseCText9:"",
    courseCText10:"",
    courseCText11:"",
    courseCText12:"",
    courseCText13:"",
    courseCText14:"",
    courseCText15:"",
    courseCText16:"",
    courseCText17:"",
    courseCText18:"",
    courseCText19:"",
    courseCText20:"",
  },

  // 招聘
  recruit:{
    recruitText1:"校园招聘",
    recruitText2:"社会招聘",
    recruitText3:"师资招聘",
  }



};



// WEBPACK FOOTER //
// ./src/lang/zh-CN.js